const f = {
  color: {
    background: "#ffffffff",
    header: {
      title: "#131b24ff",
      subtitle: "#314351ff"
    },
    border: "#dfe6ebff"
  }
};
export {
  f as page
};
